import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import DrawerCustom from '../../components/DrawerCustom'
import { Grid, ListItem, InputBase, List, ListItemText } from '@material-ui/core';
import GoogleMapComponent from '../../components/GoogleMapComponent';
import GoogleMapMarker from '../../components/GoogleMapMarker'
import { LeftIcon } from '../../components/icons';
import Container from '../../components/Container';
import CustomTypo from '../../components/CustomTypo';
import t from '../../utils/translateUtil';
import Divider from '../../components/Divider';
import InfiniteScroll from 'react-infinite-scroll-component';
const containerStyle = {
    width: '100%',
    height: '100%'
};
const styles = theme => ({
    map: {
        width: '100%',
        height: '100%'
    },
    footer: {
        height: 360,
        width: '100%',
        position: 'absolute',
        bottom: 0,
        backgroundColor: theme.palette.background.secondary,
        borderTopLeftRadius: theme.spacing(4),
        borderTopRightRadius: theme.spacing(4),
        padding: theme.spacing(4)
    },
    buttonBack: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(8),
        cursor: "pointer",
        textAlign: "center",
        touchAction: "manipulation",
        position: 'absolute',
        top: theme.spacing(5),
        left: theme.spacing(5),
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
})
function CurrentLocationMap(props) {
    const { open, onClose, address_list, showLoading, classes,currentLocation, onSelectLocation } = props;
    // console.log("OrderStoresView stores:", stores);
    return (
        <Container showLoading={showLoading}>
            <DrawerCustom
                open={open}
                onClose={onClose}
                fullScreen>
                <Grid xs={12} item className={classes.map} container>
                    <GoogleMapComponent
                        center={currentLocation}
                        onClick={(e)=>onSelectLocation(e)}>
                            
                                {currentLocation&&currentLocation.lat&&<GoogleMapMarker
                                    lat={currentLocation.lat}
                                    lng={currentLocation.lon}/>}
                    </GoogleMapComponent>
                </Grid>
                <Grid item className={classes.footer}>
                    <CustomTypo variant='subtitle2'>{t('locations')}</CustomTypo>
                    <Divider fullWidth />
                    <InfiniteScroll
                        dataLength={address_list.length} //This is important field to render the next data
                        height={300}
                    >
                        <Grid xs={12} item container>
                            {address_list.map((item, index) => (
                                <MerchantItem key = {index} item={item} index={index} onSelectAddress={props.onSelectAddress} />
                            ))}</Grid>
                    </InfiniteScroll>
                </Grid>
            </DrawerCustom>
        </Container>
    );
}
function MerchantItem(props) {
    var item = props.item;
    return (
        <Grid xs={12} item>
            <ListItem onClick={() => props.onSelectAddress(item)} style={{ cursor: 'pointer' }}>
                <Grid item>
                    <CustomTypo variant='body1'>{item.address}</CustomTypo>
                </Grid>
            </ListItem>
            <Divider fullWidth />
        </Grid>
    )
}
export default withStyles(styles)(withTranslation()(CurrentLocationMap));